class VoucherController {
    /*@ngInject*/
    constructor($log, $http, CommonService) {
        $log.debug('VoucherController initialized');
        this.$log = $log;
        this.$http = $http;
        this.CommonService = CommonService;
        this.voucherCode = null;
        this.promoCode = null;
        this.isGiftCart = null;
        this.voucherLabel = null;
        this.voucherExpired = null;
        this.requestPending = false;
    }

    setVoucher(label, expiryDate) {
        this.voucherLabel = label;
        this.voucherExpired = expiryDate;
    }


    removeVoucher(voucherId) {
        let url = this.CommonService.getBaseUrl() + '/cart/voucher/remove?voucherId=' + voucherId;
        this.requestPending = true;
        let req = {
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: {
                voucherCode: voucherId
            }
        };
        this.$http(req).then((response) => {
            window.location.reload(true);
        }, (error) => {
            this.$log.error('remove voucher request error: ' + error.status + ' ' + error.statusText);
        });
    }

    setIsGiftCart (voucherCode) {
        const regexGiftCart = /^([0-7]\d{3}|8000|8100)\d{12}$/i;

        if(regexGiftCart.test(voucherCode)) {
            this.isGiftCart = true;
        }
        else {
            this.isGiftCart = false;
        }
    }

    isPinMissing (pin) {
        return pin.length < 4 && this.isGiftCart;
    }

    getCurrentVoucher() {
        return this.voucherCode;
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }
}

export default VoucherController;
